import { useEffect } from 'react';

type UseFontLoadingObserverParams = {
  onFontLoad: () => void;
};

export const useFontLoadingObserver = (
  params: UseFontLoadingObserverParams,
) => {
  const { onFontLoad } = params;

  useEffect(() => {
    const handleFontLoad = () => {
      onFontLoad();
    };

    document.fonts.addEventListener('loadingdone', handleFontLoad);

    return () => {
      document.fonts.removeEventListener('loadingdone', handleFontLoad);
    };
  }, [onFontLoad]);
};
